import { useEffect } from 'react';

function FocusControl(isError, setIsError, formData) {
    // Focus on error
    useEffect(() => {
        document.getElementsByClassName('error')?.[0]?.classList.remove('error');

        if (isError) {
            document.getElementsByName(isError)?.[0]?.focus();
            document.getElementsByName(isError)?.[0]?.classList.add('error');
        }
    }, [isError]);

    // Remove border error
    useEffect(() => {
        setIsError(null);
    }, [formData, setIsError]);

    return null;
}

export default FocusControl;
